import React from "react";
import { usePopup } from "../context/PopupContext";

const QuotePopup = () => {
  const { isOpen, closePopup } = usePopup();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
      <div className="relative w-full max-w-md rounded-2xl border border-[#C6A564] bg-[#1a1a1a] p-8 text-[#f1f1f1] shadow-lg shadow-black/50 animate-fadeIn">
        {/* Close button */}
        <button
          onClick={closePopup}
          className="absolute top-3 right-3 text-[#C6A564] text-xl hover:text-[#d8b971] transition"
          aria-label="Close popup"
        >
          ✕
        </button>

        <h2 className="mb-4 text-center text-2xl font-semibold text-[#C6A564]">
          Request a Quote
        </h2>

        {/* Web3Forms form */}
        <form
          action="https://api.web3forms.com/submit"
          method="POST"
          className="flex flex-col gap-4"
        >
          {/* Replace with your actual access key */}
          <input
            type="hidden"
            name="access_key"
            value="2cb6df5a-2144-48dd-9cb8-c6c86d838192"
          />

          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
            className="rounded bg-[#111111] p-2 border border-[#333] focus:outline-none focus:border-[#C6A564]"
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
            className="rounded bg-[#111111] p-2 border border-[#333] focus:outline-none focus:border-[#C6A564]"
          />

          <textarea
            name="message"
            rows="4"
            placeholder="Tell us about your security needs..."
            required
            className="rounded bg-[#111111] p-2 border border-[#333] focus:outline-none focus:border-[#C6A564]"
          ></textarea>

          {/* Removed hCaptcha widget completely */}

          <button
            type="submit"
            className="mt-4 rounded-lg bg-[#C6A564] py-2 font-semibold text-black transition hover:bg-[#b8974f]"
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default QuotePopup;

